import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-72d97c98"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "building" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("span", null, "玩家登录")
], -1))

import {onMounted, reactive, ref , onUnmounted } from 'vue'
import { useStore } from 'vuex';
import type { FormInstance, FormRules } from 'element-plus'
import route from '@/router/index';
import { post, get } from '@/ts/request';
import { ElMessage } from 'element-plus'
import { LOGIN_URL , PLAYER_INFO_URL } from '@/ts/url';



export default /*#__PURE__*/_defineComponent({
  __name: 'login',
  setup(__props) {


const ruleFormRef = ref<FormInstance>()
const store = useStore();

// 支持enter 提交表单
onMounted(() => {
    window.addEventListener('keydown' , (event: any) => {
        if(event.key === 'Enter'){
            submitForm(ruleFormRef.value)
        }
    })
})
onUnmounted(() => {
    window.removeEventListener('keydown' , (event: any) => {
        if(event.key === 'Enter'){
            submitForm(ruleFormRef.value)
        }
    })
})

const validatePass = (rule: any, value: any, callback: any) => {
    if (value === '' || !value) {
        callback(new Error('Please input the password'))
    } else {

        callback()
    }
}

const validateName = (rule: any, value: any, callback: any) => {
    if (value === '') {
        callback(new Error('Please input the user name'))
    } else {
        callback()
    }
}


const ruleForm = reactive({
    password: '',
    username: '',
})

const rules = reactive<FormRules<typeof ruleForm>>({
    username: [{ validator: validateName, trigger: 'blur' }],
    password: [{ validator: validatePass, trigger: 'blur' }],
})

const submitForm = (formEl: FormInstance | undefined) => {
    if (!formEl) return
    formEl.validate(async (valid) => {

        if (valid) {
            let response = await post(LOGIN_URL, '', ruleForm)
            if (response.code != 1001){
                ElMessage({
                    message: response.msg,
                    grouping: true,
                    offset: 50,
                    type: 'error',
                })
                return
            }
            let playerInfo = await get(PLAYER_INFO_URL, response.data.accessToken)  

            store.commit('setToken', response.data)
            store.commit('setUserInfo', playerInfo.data)
            route.push({ name: 'main' })
        } else {
            console.log('error submit!')
        }
    })
}

function toRegister() {
    route.push({ name: 'register' })
}



return (_ctx: any,_cache: any) => {
  const _component_el_header = _resolveComponent("el-header")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_container, { style: {"margin-top":"30vh","margin-left":"57vw"} }, {
      default: _withCtx(() => [
        _createVNode(_component_el_header, { style: {"height":"20vh"} }),
        _createVNode(_component_el_card, { style: {"max-width":"360px","text-align":"center"} }, {
          header: _withCtx(() => [
            _hoisted_2
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "ruleFormRef",
              ref: ruleFormRef,
              model: ruleForm,
              "status-icon": "",
              rules: rules,
              "label-width": "auto",
              class: "demo-ruleForm"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "用户名",
                  prop: "username",
                  class: "item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: ruleForm.username,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((ruleForm.username) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "密码",
                  prop: "password",
                  class: "item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: ruleForm.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((ruleForm.password) = $event)),
                      type: "password",
                      autocomplete: "off"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (submitForm(ruleFormRef.value))),
                      style: {"position":"relative","left":"6vw","background-color":"transparent"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Submit ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (toRegister())),
                      style: {"position":"relative","left":"7vw","background-color":"transparent"}
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Register ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "rules"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})